import React, { useState } from 'react';
import { ImageOff, Eye, X } from 'lucide-react';

export const BannerThumbnail = ({ src, alt = 'Banner', title = '' }) => {
  const [hasError, setHasError] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  if (!src || hasError) {
    return (
      <div
        className="banner-thumb-fallback"
        title={`Image not available: ${alt}`}
      >
        <ImageOff size={16} className="banner-thumb-icon" />
        <span className="banner-thumb-fallback-text">No Image</span>
      </div>
    );
  }

  return (
    <>
      <div
        className="banner-thumb-wrapper"
        onClick={() => setShowPreview(true)}
        title="Click to view full banner"
      >
        <img
          src={src}
          alt={alt}
          className="banner-thumb-img"
          onError={() => setHasError(true)}
          loading="lazy"
        />
        <div className="banner-thumb-overlay">
          <Eye size={13} />
        </div>
      </div>

      {showPreview && (
        <div className="banner-preview-modal-overlay" onClick={() => setShowPreview(false)}>
          <div className="banner-preview-modal" onClick={(e) => e.stopPropagation()}>
            <div className="banner-preview-header">
              <h4>{title || alt || 'Banner Preview'}</h4>
              <button
                type="button"
                className="banner-preview-close"
                onClick={() => setShowPreview(false)}
                aria-label="Close preview"
              >
                <X size={18} />
              </button>
            </div>
            <div className="banner-preview-body">
              <img src={src} alt={alt} className="banner-preview-full-img" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BannerThumbnail;
